import React, { useState, useEffect } from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { AiOutlineFilePdf, AiOutlineFire, AiOutlineMenu } from 'react-icons/ai';
import { IoIosSnow, IoMdSettings } from 'react-icons/io';
import { TiBatteryFull, TiBatteryHigh, TiBatteryLow, TiBatteryMid, TiLeaf, TiWarningOutline } from 'react-icons/ti';
import Moment from 'react-moment';
import ReactTooltip from "react-tooltip";

import './index.css'
import { BsFillBarChartFill, BsThreeDotsVertical } from 'react-icons/bs';
import { RiFileExcel2Line } from 'react-icons/ri';
import ws from './../../../../utils/Socket';

function DeviceList({ travel, callbackDevices, callbackModal, reportCallback, logAccess, user }) {
  const [devices, setDevices] = useState(null) // dispositivos

  useEffect(() => {
    setDevices(travel['devices'])
  }, [])

  useEffect(() => {
    init(travel)
  }, [travel])

  function init(travel) {
    const socket = ws.getSubscription('travel-logs:' + travel._id)
    if (!socket) {
      ws.subscribe('travel-logs:' + travel._id);
      ws.getSubscription('travel-logs:' + travel._id).on('message', message => {
        setDevices(message)
        console.log('message', message)
      });
    }
  }

  function renderStatusIcon(temperatureClass) {
    switch (temperatureClass) {
      case 'normal':
        return (<TiLeaf />)
      case 'hot':
        return (<AiOutlineFire />)
      case 'cold':
        return (<IoIosSnow />)
      case 'none':
        return (<TiWarningOutline />)
      default:
        return (<TiWarningOutline />)
    }
  }

  function renderBatteryStatus(battery) {
    if (battery <= 20) {
      return <TiBatteryLow size="1em" />
    } else if (battery <= 50) {
      return <TiBatteryMid size="1em" />
    } else if (battery <= 80) {
      return <TiBatteryHigh size="1em" />
    } else if (battery === 100) {
      return <TiBatteryFull size="1em" />
    }
  }

  function renderDeviceDetails(device) {
    let temperatureClass = 'none'

    if (device.temperature.value > parseFloat(device.config.temperature.max)) {
      temperatureClass = 'hot'
    } if (device.temperature.value < parseFloat(device.config.temperature.min)) {
      temperatureClass = 'cold'
    } if (device.temperature.value > parseFloat(device.config.temperature.min) &&
      device.temperature.value < parseFloat(device.config.temperature.max)) {
      temperatureClass = 'normal'
    } if (!device.config.temperature.max || !device.config.temperature.min) {
      temperatureClass = 'none'
    }

    return (
      <div className={'device ' + temperatureClass}>
        <div className="device-header">
          <div className="device-title">
            {device.name}
          </div>
          <div className="container-actions">
            <>
              <span>{device.battery.value}%</span>
              {renderBatteryStatus(device.battery.value)}
              <Dropdown>
                <Dropdown.Toggle variant="none" id="dropdown-basic">
                  <AiOutlineMenu style={{ marginLeft: '0rem' }} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      console.log('callback modal here')
                      callbackModal(device, 'graph')
                    }}>
                    Gráficos
                      <BsFillBarChartFill />
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      callbackDevices(device, 'markers')
                      if (logAccess) {
                        logAccess()
                      }
                    }}>
                    Histórico
                    </Dropdown.Item>
                  {!logAccess &&
                    <Dropdown.Item
                      onClick={() => {
                        callbackModal(device, 'settings', travel)
                      }}>
                      Configurações
                          <IoMdSettings />
                    </Dropdown.Item>
                  }
                  <Dropdown.Divider />
                  <Dropdown.Header>Relatórios</Dropdown.Header>
                  <Dropdown.Item
                    style={{ color: 'red' }}
                    onClick={() => {
                      reportCallback(travel._id, device.mac, 'pdf')
                    }}>
                    PDF
                      <AiOutlineFilePdf />
                  </Dropdown.Item>
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={() => {
                      reportCallback(travel._id, device.mac, 'excel')
                    }}>
                    EXCEL
                      <RiFileExcel2Line />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          </div>
        </div>
        <div className="device-body">
          <div className="temperature">
            <label>Temperatura</label>
            <span>{Object.keys(device.temperature).length ?
              device.temperature.value
              :
              '-.- '
            }°C</span>
          </div>
          <div className="umidity">
            <label>Umidade</label>
            <span>{Object.keys(device.humidity).length ?
              device.humidity.value
              :
              '-.- '
            }%</span>
          </div>
          <div className="status-icon-list">
            {renderStatusIcon(temperatureClass)}
          </div>
          {device.last_update_date !== null &&
            <div className="update-date">
              <span><Moment format="DD/MM/YYYY H:mm:ss">{device.last_update_date}</Moment></span>
            </div>
          }
        </div>
      </div>
    )
  }

  return (
    <div className="DeviceList">
      <Row>
        {devices && travel['devices'].map((device, index) => (
          <Col md={4} key={index}>
            {renderDeviceDetails(device)}
          </Col>
        ))}
      </Row>
      <ReactTooltip />
    </div>
  );
}

export default DeviceList;

